export enum OBOActionTypes {
    ADD_OBO_ENTITY="ADD_OBO_ENTITY",
    REMOVE_OBO_ENTITY="REMOVE_OBO_ENTITY",
    
}